module.exports = __webpack_public_path__ + "img/A.69b164fa.png";